"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var texts_1 = __importDefault(require("../../constrains/locale/texts"));
var value_checker_1 = __importDefault(require("../validation/value_checker"));
var date_parser_1 = __importDefault(require("../date/date_parser"));
var dayjs_1 = __importDefault(require("dayjs"));
var SalesForceObjectUtils = /** @class */ (function () {
    function SalesForceObjectUtils() {
    }
    SalesForceObjectUtils.getSalesForcePeriod = function (dbValue) {
        var result = '';
        texts_1.default.ja.view.contract_form.update.data_labels.apply_info.period.some(function (data) {
            if (data.value === dbValue) {
                result = data.sales_force_value;
                // Break;
                return true;
            }
        });
        console.log(dbValue);
        console.log(result);
        return result;
    };
    SalesForceObjectUtils.getSalesForceHowToApply = function (dbValue) {
        var result = '';
        texts_1.default.ja.view.contract_form.update.data_labels.request_info.how_to_request.some(function (data) {
            if (data.value === dbValue) {
                result = data.sales_force_value;
                // Break;
                return true;
            }
        });
        console.log(dbValue);
        console.log(result);
        return result;
    };
    SalesForceObjectUtils.getDBHowToApplyValue = function (salesForceValue) {
        var result = salesForceValue;
        texts_1.default.ja.view.contract_form.update.data_labels.request_info.how_to_request.some(function (data) {
            if (data.sales_force_value === salesForceValue) {
                result = data.value;
                // Break;
                return true;
            }
        });
        return result;
    };
    SalesForceObjectUtils.getBikoHtml = function (dbValue) {
        if (value_checker_1.default.isBlank(dbValue)) {
            return '';
        }
        return dbValue.replace(/\n/g, '<br>');
    };
    SalesForceObjectUtils.getApplyPlanText = function (planName, priceBookName) {
        if (value_checker_1.default.isBlank(planName)) {
            return '';
        }
        if (value_checker_1.default.isBlank(priceBookName)) {
            return planName;
        }
        return planName + "\uFF08" + priceBookName + "\uFF09";
    };
    SalesForceObjectUtils.getPlanPeriodStr = function (planSdateStr, freePeriodStr, planPeriodStr, ProductPlanName) {
        // 期間が未入力の場合は空文字を返す。
        ProductPlanName = value_checker_1.default.isPresent(ProductPlanName) ? ProductPlanName : '';
        // 未入力状態は計算不能。
        if (value_checker_1.default.isBlank(planSdateStr) || value_checker_1.default.isBlank(planPeriodStr)) {
            return '';
        }
        //　日付不正は計算不能。
        var planStartDateTime = Date.parse(planSdateStr);
        if (isNaN(planStartDateTime)) {
            return '';
        }
        var freePeriod = Number(freePeriodStr);
        if (isNaN(freePeriod)) {
            freePeriod = 0;
        }
        var planPriod = Number(planPeriodStr);
        if (isNaN(planPriod)) {
            planPriod = 0;
        }
        var sdate = new Date(planStartDateTime);
        if (planPriod === 1 && (ProductPlanName === '月間' || ProductPlanName === 'tablet')) {
            return date_parser_1.default.toJapaneseDateStrFromTime(sdate.getTime()) + " ~";
        }
        var edate = new Date(sdate.getFullYear(), sdate.getMonth() + freePeriod + planPriod, 0);
        return date_parser_1.default.toJapaneseDateStrFromTime(sdate.getTime()) + " ~ " + date_parser_1.default.toJapaneseDateStrFromTime(edate.getTime());
    };
    SalesForceObjectUtils.getEdateFromSdate = function (planSdateStr, periodStr) {
        var planStartDateTime = Date.parse(planSdateStr);
        var period = Number(periodStr);
        if (isNaN(period)) {
            period = 1;
        }
        var sdate = new Date(planStartDateTime);
        var edate = new Date(sdate.getFullYear(), sdate.getMonth() + period, 0);
        return date_parser_1.default.toString(edate);
    };
    SalesForceObjectUtils.getSdateNextContract = function (planSdateStr, periodStr) {
        var planStartDateTime = Date.parse(planSdateStr);
        var period = Number(periodStr);
        if (isNaN(period)) {
            period = 1;
        }
        var sdate = new Date(planStartDateTime);
        var nextSdate = new Date(sdate.getFullYear(), sdate.getMonth() + period, 1);
        return date_parser_1.default.toString(nextSdate);
    };
    SalesForceObjectUtils.compareBwetweeYearMonth = function (compareDate1, compareDate2, formatType) {
        // TODO 今後のためにformatTypeを拡充すること
        if (formatType === "YearMonth") {
            compareDate1 = dayjs_1.default(compareDate1).format('YYYY-MM');
            compareDate2 = dayjs_1.default(compareDate2).format('YYYY-MM');
            var dateFrom = dayjs_1.default(compareDate1);
            var dateTo = dayjs_1.default(compareDate2);
            var comparisonResult = dateFrom.diff(dateTo, 'month');
            return comparisonResult;
        }
    };
    SalesForceObjectUtils.isWithinPeriod = function (start, end, target) {
        var startDate = dayjs_1.default(start);
        var endDate = dayjs_1.default(end);
        var targetDate = dayjs_1.default(target);
        return targetDate.isAfter(startDate) && targetDate.isBefore(endDate);
    };
    // 2024年01月01日〜2024年03月31日までの限定プラン表示
    SalesForceObjectUtils.limitedPlanTexts = function (reflectTextType, toUpgradeData, toUpgradeSelectedItem, previousPlan, afterPlan, toUpgradeStartDate) {
        var today = new Date().toLocaleDateString('en-CA');
        var isLimitedPeriodWithIn = this.isWithinPeriod('2023-12-01', '2024-03-31', today);
        // let isNewPlanStartDateBasic = DayJs(toUpgradeStartDate).isAfter('2024-01-01') || DayJs(toUpgradeStartDate).isAfter('2024-03-01');
        var isNewPlanStartDateBasic = this.isWithinPeriod('2023-12-01', '2024-03-31', toUpgradeStartDate);
        var isNewPlanStartDateStandard = dayjs_1.default(toUpgradeStartDate).isSame('2024-04-01') || dayjs_1.default(toUpgradeStartDate).isAfter('2024-04-01');
        // console.log('isNewPlanStartDateStandard', isNewPlanStartDateStandard);
        // sales事前画面_申込OBJへの反映
        if (reflectTextType === 'scheduled_application') {
            var result = '';
            if (isLimitedPeriodWithIn &&
                ((toUpgradeData.familyName === 'Rehab Cloud Standard' && (toUpgradeSelectedItem === 'Medium to Standard' || toUpgradeSelectedItem === 'Medium to Pro')) ||
                    (toUpgradeData.familyName === 'Rehab Cloud Basic' && toUpgradeSelectedItem === 'Basic to Medium'))) {
                switch (toUpgradeData.familyName) {
                    case 'Rehab Cloud Standard':
                        if (toUpgradeSelectedItem === 'Medium to Standard' && isNewPlanStartDateStandard) {
                            result += "\u25A1 UPGRADE Rehab Cloud Standard\uFF082024\u5E744\u6708\u3088\u308AMedium) to Standard\n";
                            result += "   \u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u524D: Rehab Cloud Standard\uFF082024\u5E744\u6708\u3088\u308AMedium\uFF09\n";
                        }
                        else if (toUpgradeSelectedItem === 'Medium to Pro' && isNewPlanStartDateStandard) {
                            result += "\u25A1 UPGRADE Rehab Cloud Standard\uFF082024\u5E744\u6708\u3088\u308AMedium) to Pro\n";
                            result += "   \u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u524D: Rehab Cloud Standard\uFF082024\u5E744\u6708\u3088\u308AMedium\uFF09\n";
                        }
                        break;
                    case 'Rehab Cloud Basic':
                        result += toUpgradeSelectedItem === 'Basic to Medium' && isNewPlanStartDateBasic ? "\u25A1 UPGRADE Rehab Cloud Basic to Rehab Cloud Standard\uFF082024\u5E744\u6708\u3088\u308AMedium) \n" : "\u25A1 UPGRADE Rehab Cloud Basic to Rehab Cloud Medium \n";
                        result += "   \u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u524D: Rehab Cloud Basic\n";
                        break;
                    default:
                        break;
                }
                return result;
            }
            else {
                result += "\u25A1 UPGRADE " + toUpgradeSelectedItem + "\n";
                result += "   \u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u524D: " + previousPlan + "\n";
                return result;
            }
        }
        // 申込みフォーム_申込確認画面への反映_previousPlan 主に旧スタンダードプランからのアップグレード
        if (reflectTextType === 'apply_info_previous_plan') {
            var result = '';
            if ((isLimitedPeriodWithIn && isNewPlanStartDateStandard) &&
                ((toUpgradeData.familyName === 'Rehab Cloud Standard') && (toUpgradeSelectedItem === 'Medium to Standard' || toUpgradeSelectedItem === 'Medium to Pro'))) {
                result = "Rehab Cloud Standard\uFF082024\u5E744\u6708\u3088\u308AMedium\uFF09";
                return result;
            }
            else {
                result = previousPlan;
                return result;
            }
        }
        // 申込みフォーム_申込確認画面への反映_afterPlan 主にBasic to Medium
        if (reflectTextType === 'apply_info_after_plan') {
            var result = '';
            if ((isLimitedPeriodWithIn && isNewPlanStartDateBasic) &&
                ((toUpgradeData.familyName === 'Rehab Cloud Basic' && toUpgradeSelectedItem === 'Basic to Medium'))) {
                result = "Rehab Cloud Standard\uFF082024\u5E744\u6708\u3088\u308AMedium)";
                return result;
            }
            else {
                result = afterPlan;
                return result;
            }
        }
        // 申込みフォーム完了後／契約確定のメール文のタイトル 主にBasic to Medium
        if (reflectTextType === 'input_complete_upgrade_title') {
            var result = '';
            if ((isLimitedPeriodWithIn && isNewPlanStartDateBasic) &&
                ((toUpgradeData.familyName === 'Rehab Cloud Basic' && toUpgradeSelectedItem === 'Basic to Medium'))) {
                result = "Rehab Cloud Standard\uFF082024\u5E744\u6708\u3088\u308AMedium)";
                return result;
            }
            else {
                result = afterPlan;
            }
            return result;
        }
        // 申込みフォーム完了後／契約確定のメール文_previousPlan 主に旧スタンダードプランからのアップグレード
        if (reflectTextType === 'input_complete_previous_plan') {
            var result = '';
            if ((isLimitedPeriodWithIn && isNewPlanStartDateStandard) &&
                ((toUpgradeData.familyName === 'Rehab Cloud Standard') && (toUpgradeSelectedItem === 'Medium to Standard' || toUpgradeSelectedItem === 'Medium to Pro'))) {
                result = "Rehab Cloud Standard\uFF082024\u5E744\u6708\u3088\u308AMedium\uFF09";
                return result;
            }
            else {
                result = previousPlan;
                return result;
            }
        }
        // 申込みフォーム完了後／契約確定のメール文_afterPlan 主にBasic to Medium
        if (reflectTextType === 'input_complete_after_plan') {
            var result = '';
            if ((isLimitedPeriodWithIn && isNewPlanStartDateBasic) &&
                ((toUpgradeData.familyName === 'Rehab Cloud Basic' && toUpgradeSelectedItem === 'Basic to Medium'))) {
                result = "Rehab Cloud Standard\uFF082024\u5E744\u6708\u3088\u308AMedium)";
                return result;
            }
            else {
                result = afterPlan;
                return result;
            }
        }
    };
    SalesForceObjectUtils.getTokubetuFlg = function (tokubetuDetail) {
        if (value_checker_1.default.isPresent(tokubetuDetail)) {
            return 'true';
        }
        return '';
    };
    SalesForceObjectUtils.getItPeriod = function (itFlg, term) {
        if (value_checker_1.default.isPresent(itFlg) && term === '2年') {
            return '2年';
        }
        if (value_checker_1.default.isPresent(itFlg)) {
            return '1年';
        }
        if (term === '年間') {
            return '1年';
        }
        return '';
    };
    /**
     *
     * @param dateStr
     */
    SalesForceObjectUtils.isInContract = function (dateStr) {
        var contractStartDate = Date.parse(dateStr);
        if (isNaN(contractStartDate)) {
            return false;
        }
        return new Date().getTime() > contractStartDate;
    };
    SalesForceObjectUtils.getContractState = function (dateStr) {
        if (SalesForceObjectUtils.isInContract(dateStr)) {
            return '契約中';
        }
        else {
            return '契約前';
        }
    };
    SalesForceObjectUtils.getStageName = function () {
        return '受注';
    };
    SalesForceObjectUtils.getRecordTypeId = function () {
        return '0122j0000008UZMAA2';
    };
    Object.defineProperty(SalesForceObjectUtils, "PERSONAL_EKYC_APPROVED", {
        get: function () {
            return '審査OK';
        },
        enumerable: true,
        configurable: true
    });
    return SalesForceObjectUtils;
}());
exports.default = SalesForceObjectUtils;



//////////////////
// WEBPACK FOOTER
// ./common/src/utils/sales_force/object_utils.ts
// module id = Y1Ni
// module chunks = 1